import ActionTypeZona from "../ActionTypeZona";
import ActionZonaSet from "../ActionZonaSet";

export default class SetRowZonaSelected extends ActionTypeZona {
    ejecutar(estado, nuevoEstado) {
        // super.ejecutar(estado, nuevoEstado);
        new ActionZonaSet("indexRowSelected", this.payload.index).ejecutar(estado, nuevoEstado);
        new ActionZonaSet("rowSelected", this.payload.rowSelected).ejecutar(estado, nuevoEstado);
        // new ActionZonaSet("rowSelected",estado.output.domain.resultSet[this.payload]).ejecutar(estado,nuevoEstado);
        new ActionZonaSet("nombre", this.payload.rowSelected.nombre).ejecutar(estado, nuevoEstado);
        // new ActionZonaSet("nombre", estado.output.domain.resultSet[this.payload].nombre).ejecutar(estado,nuevoEstado);
        return nuevoEstado;
    }
}
